<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Sponsor中文名称" prop="supplierName">
                      <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Sponsor英文名称" prop="supplierNameEn">
                      <el-input v-model="queryCondition.supplierNameEn" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Sponsor简称" prop="supplierNameShort"> 
                      <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                      <!-- <el-select v-model="queryCondition.category2CodeList" @change="changeCategory2" multiple  clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                      </el-select> -->
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodeList">
                      <el-select v-model="queryCondition.category3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                         <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-col>
            <!-- <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable  filterable placeholder="请选择" style="width:100%">
                         <el-option :key="index" v-for="(item,index) in statusOptions" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  
                </el-row>
              </el-col>
            </el-collapse-transition> -->
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
          
        </el-form>
      </div>
      <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline" >
        <el-form-item label="">
          <el-button size="mini" class="btn" type="primary" @click="selectData">选择</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="plxTable" border   :data="tableData" max-height="500" show-overflow="ellipsis" highlight-current-row>
        <!-- <el-table-column align="center" type="selection" width="80" /> -->
        <el-table-column prop="date" label="" width="90">
          <template slot-scope="scope">
              <el-radio :label="scope.row.supplierCode" v-model="templateRadio" @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Sponsor中文名称" min-width="140" prop="supplierName"></el-table-column>
        <el-table-column align="center" label="Sponsor英文名称" min-width="140" prop="supplierNameEn"></el-table-column>
        <el-table-column align="center" label="Sponsor简称" min-width="100" prop="supplierNameShort"></el-table-column>
        <!-- <el-table-column align="center" label="供应商集团编码" min-width="140" prop="groupCode"></el-table-column>
        <el-table-column align="center" label="供应商集团名称" min-width="140" prop="groupName"></el-table-column>
        <el-table-column align="center" label="状态" min-width="100" prop="statusView"></el-table-column>
        <el-table-column align="center" label="更新人" min-width="120" prop="updateBy"></el-table-column>
        <el-table-column align="center" label="更新日期" min-width="100" prop="updateDate"></el-table-column>
        <el-table-column align="center" label="创建日期" min-width="120" prop="createDate"></el-table-column>
        <el-table-column align="center" label="最新供货月份" min-width="120" prop="lastSuppliedMonth"></el-table-column>
        <el-table-column align="center" label="最新月供货量" min-width="120" prop="lastSuppliedQty"></el-table-column> -->
      </el-table>
    </div>
    <!-- <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData"></detailDialog>
    </el-dialog> -->
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ratingTask from "@/api/AAA/ratingTask.js";
import apiService  from "@/api/AAA/index.js";
import QBRApi from "@/api/QBR/index";


// import detailDialog from './MaintainceFacility.vue'
export default {
  name: '',
  components: {
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      templateRadio:"",
      formInline:{
        endDate:"",
      },
      statusOptions:[{
        label:"新增",
        value:"NEW"
      },{
        label:"启用",
        value:"ACTIVE"
      },{
        label:"禁用",
        value:"INACTIVE"
      }],
      multipleSelection:[],
      categoryList2: [],
      categoryList3: [],
      queryCondition: {
        supplierName:"",
        supplierNameEn:"",
        supplierNameShort:""
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
    }
  },
  created() {
    this.queryData();
    this.getCategory2Lists()
    this.getCategory3Lists()
  },
  methods: {
    queryData() {
      ratingTask.getSponsorList(this.queryCondition).then((res)=>{
        this.tableData=res.data
      })
    },
    onDetail(row){
      this.showDetailDialog=true
      this.formData=JSON.stringify(row)
    },
    // selectionChange(val){
    //   this.multipleSelection=val
    // },
    onReset() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition={
         supplierName:"",
         supplierNameEn:"",
         supplierNameShort:""
      },
      this.queryData()
    },
    selectData() {
      this.$emit("selectData",this.multipleSelection)
    },
    // 单选获取的数据
    getTemplateRow(index,row){
      this.multipleSelection.push(row)
      // this.getRadioVal=row.invoiceHeaderId
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        console.log("111111111111",res)
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
  },
}
</script>
<style scoped >
</style>
